import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useMeterAssignment} from "../hooks/useMeterAssignment.ts";
import {AssignmentStatus, MeterAssignment} from "../types.ts";

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createMutation,
    } = useMeterAssignment();

    // mutateAsync, not mutate: the drawer must know whether the create succeeded. The
    // mutation's own onError already notifies, so a failure only needs to keep it open.
    const handleSubmit = async (values: MeterAssignment) => {
        try {
            await createMutation.mutateAsync(values);
            return true;
        } catch {
            return false;
        }
    };

    return (
        <FormDrawer
            record={{
                id: '',
                customerId: '',
                meterId: '',
                // FNP-616: empty default — the user picks from the catalog-driven channel
                // options (no hardcoded provider).
                channel: '',
                channelIdentifiers: {},
                status: AssignmentStatus.ACTIVE,
                effectiveFrom: '',
            } as MeterAssignment}
            handleSubmit={handleSubmit}
            {...props}
        />
    )
};
